var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Pencil 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M22.0628 10.5518C22.252 10.3626 22.5588 10.3626 22.748 10.5518L24.8035 12.6073C24.9927 12.7965 24.9927 13.1033 24.8035 13.2925L23.2276 14.8684L20.4869 12.1277L22.0628 10.5518Z",
    fill: "#36383D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M19.7332 12.8814L22.4739 15.6221L14.4573 23.6388L11.7165 20.898L19.7332 12.8814Z",
    fill: "#36383D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M11.648 23.7073L11.7221 20.9036L14.4517 23.6332L11.648 23.7073Z",
    fill: "#36383D"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.d2887595b641ea6944f6bdd84d6c97bb.svg";
export { ForwardRef as ReactComponent };